import QrcodeVue from 'qrcode.vue';

import SmallTitle from '@/components/elementos/SmallTitle/SmallTitle.vue';
import SmallError from '@/components/elementos/SmallError/SmallError.vue';
import EditorTexto from '@/components/elementos/EditorTexto/EditorTexto.vue';
import ReturnTrail from '@/components/elementos/ReturnTrail/ReturnTrail.vue';
import CardMobile from '@/components/elementos/CardMobile/CardMobile.vue';
import CardInformacao from '@/components/elementos/CardInformacao/CardInformacao.vue';
import CardArquivo from '@/components/elementos/CardArquivo/CardArquivo.vue';
import TourGuiado from '@/components/elementos/TourGuiado/TourGuiado.vue';
import LeitorPdf from '@/components/LeitorPdf/LeitorPdf.vue';

import TagStatusSolicitacoes from '@/components/elementos/TagStatus/TagStatusSolicitacoes.vue';
import TagStatusPagamentos from '@/components/elementos/TagStatus/TagStatusPagamentos.vue';
import TagStatusContratacao from '@/components/elementos/TagStatus/TagStatusContratacao.vue';
import TagStatusRelatorioViagem from '@/components/elementos/TagStatus/TagStatusRelatorioViagem.vue';
import TagStatusSolicitacaoPagamentoBeneficio from '@/components/elementos/TagStatus/TagStatusSolicitacaoPagamentoCLT.vue';
import TagStatus from '@/modules/projeto/components/elements/TagStatus.vue';
import TagStatusDiaria from '@/components/elementos/TagStatus/TagStatusDiaria.vue';
import TagDefault from '@/components/elementos/TagDefault/TagDefault.vue';
import TagBase from '@/components/elementos/TagBase/TagBase.vue';

import TabelaHistorico from '@/components/elementos/Tabelas/TabelaHistorico.vue';
import LabelDados from '@/components/elementos/LabelDados/LabelDados.vue';

import CabecalhoFormSolicitacoes from '@/modules/projeto/components/forms/CabecalhoFormSolicitacoes.vue';
import DetalhamentoInput from '@/modules/projeto/components/inputs/DetalhamentoInput.vue';
import MetaInput from '@/modules/projeto/components/inputs/MetaInput.vue';
import RubricaInput from '@/modules/projeto/components/inputs/RubricaInput.vue';
import RubricaInputNew from '@/modules/projeto/components/inputs/RubricaInputNew.vue';
import PropostaReferenciaInput from '@/modules/projeto/components/inputs/PropostaReferenciaInput.vue';
import CboInput from '@/modules/projeto/components/inputs/CboInput.vue';

import BotaoRascunho from '@/components/elementos/BotaoRascunho/BotaoRascunho.vue';
import BotaoAba from '@/components/elementos/BotaoAba/BotaoAba.vue';
import AbaNavegacao from '@/components/elementos/AbaNavegacao/AbaNavegacao.vue';
import Carregador from '@/components/elementos/Carregador/Carregador.vue';

import CabecalhoListas from '@/components/Tabelas/CabecalhoListas/CabecalhoListas.vue';
import ColunaListas from '@/components/Tabelas/ColunaListas/ColunaListas.vue';
import CardMobileLista from '@/components/Tabelas/CardMobileLista/CardMobileLista.vue';
import PaginadorTabela from '@/components/Tabelas/PaginadorTabela/PaginadorTabela.vue';
import CampoBuscaLista from '@/components/Tabelas/CampoBuscaLista/CampoBuscaLista.vue';
import BotaoFiltroToggle from '@/components/elementos/BotaoFiltroToggle/BotaoFiltroToggle.vue';
import BotaoFiltro from '@/components/Tabelas/BotaoFiltro/BotaoFiltro.vue';
import BotaoExibirTodos from '@/components/Tabelas/BotaoExibirTodos/BotaoExibirTodos.vue';

import DialogoFormulario from '@/components/Dialogos/DialogoFormulario/DialogoFormulario.vue';
import DialogoDetalhe from '@/components/Dialogos/DialogoDetalhe/DialogoDetalhe.vue';
import DialogoLista from '@/components/Dialogos/DialogoLista/DialogoLista.vue';
import DialogoPdf from '@/components/Dialogos/DialogoPdf/DialogoPdf.vue';
import InfoInstrucaoArquivo from '@/components/Dialogos/Info/InfoInstrucaoArquivo.vue';

import BaseCadastros from '@/components/Cadastros/BaseCadastros/BaseCadastros.vue';
import FormCadastros from '@/components/Cadastros/FormCadastros/FormCadastros.vue';
import CabecalhoCadastros from '@/components/Cadastros/CabecalhoCadastros/CabecalhoCadastros.vue';
import DivisaoCadastros from '@/components/Cadastros/DivisaoCadastros/DivisaoCadastros.vue';

import Rubrica from '@/components/Cadastros/CamposGenericos/Rubrica.vue';
import RubricaDetalhamento from '@/components/Cadastros/CamposGenericos/RubricaDetalhamento.vue';
import Meta from '@/components/Cadastros/CamposGenericos/Meta.vue';
import TextoCampo from '@/components/Cadastros/CamposGenericos/TextoCampo/TextoCampo.vue';
import TextoMaskCampo from '@/components/Cadastros/CamposGenericos/TextoMaskCampo/TextoMaskCampo.vue';
import DropdownCampo from '@/components/Cadastros/CamposGenericos/DropdownCampo/DropdownCampo.vue';
import MultiSelectCampo from '@/components/Cadastros/CamposGenericos/MultiSelectCampo/MultiSelectCampo.vue';
import RadioCampo from '@/components/Cadastros/CamposGenericos/RadioCampo/RadioCampo.vue';
import SelectButtonCampo from '@/components/Cadastros/CamposGenericos/SelectButtonCampo/SelectButtonCampo.vue';
import TextoAreaCampo from '@/components/Cadastros/CamposGenericos/TextoAreaCampo/TextoAreaCampo.vue';
import DataPagamento from '@/components/Cadastros/CamposGenericos/DataPagamentoCampo/DataPagamentoCampo.vue';
import Arquivo from '@/components/Cadastros/CamposGenericos/Arquivo.vue';
import TipoSolicitacao from '@/components/Cadastros/CamposGenericos/TipoSolicitacao.vue';
import Membros from '@/components/Cadastros/CamposGenericos/Membro.vue';
import Valor from '@/components/Cadastros/CamposGenericos/Valor.vue';
import ValorNumericoCampo from '@/components/Cadastros/CamposGenericos/ValorNumericoCampo/ValorNumericoCampo.vue';
import TipoSolicitacaoFinanceiro from '@/components/Cadastros/CamposGenericos/TipoSolicitacaoFinanceiro.vue';
import MembroPagamento from '@/components/Cadastros/CamposGenericos/MembroPagamento.vue';
import Switch from '@/components/Cadastros/CamposGenericos/Switch.vue';
import PessoaFisica from '@/components/Cadastros/CamposGenericos/PessoaFisica.vue';
import Projeto from '@/components/Cadastros/CamposGenericos/Projeto.vue';
import PessoaJuridica from '@/components/Cadastros/CamposGenericos/PessoaJuridica.vue';
import AvisoCoordenacao from '@/components/Cadastros/CamposGenericos/AvisoCoordenacao.vue';
import ContaBancaria from '@/components/Cadastros/CamposGenericos/ContaBancaria.vue';
import ContaBancariaCampoValidado from '@/components/Cadastros/CamposGenericos/ContaBancariaCampo/ContaBancariaCampo.vue';

import ListasGenericas from '@/components/Tabelas/ListasGenericas/ListasGenericas.vue';
import TabelaScrollContainer from '@/components/Tabelas/TabelaScrollContainer/TabelaScrollContainer.vue';
import BaseDetalhes from '@/components/Detalhes/BaseDetalhes/BaseDetalhes.vue';

import LabelsGerais from '@/modules/projeto/components/detalhesSolicitacao/LabelsGerais.vue';
import LabelsMateriais from '@/modules/projeto/components/detalhesSolicitacao/LabelsMateriais.vue';
import LabelsServicos from '@/modules/projeto/components/detalhesSolicitacao/LabelsServicos.vue';
import LabelsLocacao from '@/modules/projeto/components/detalhesSolicitacao/LabelsLocacao.vue';
import LabelsPassagem from '@/modules/projeto/components/detalhesSolicitacao/LabelsPassagem.vue';
import LabelsHospedagem from '@/modules/projeto/components/detalhesSolicitacao/LabelsHospedagem.vue';
import LabelsRecargaCartao from '@/modules/projeto/components/detalhesSolicitacao/LabelsRecargaCartao.vue';
import LabelsCadastroPJ from '@/modules/projeto/components/detalhesSolicitacao/LabelsCadastroPJ.vue';
import LabelsCadastroPF from '@/modules/projeto/components/detalhesSolicitacao/LabelsCadastroPF.vue';
import LabelsPagamentoMaterial from '@/modules/projeto/components/detalhesSolicitacao/LabelsPagamentoMaterial.vue';
import LabelsPagamentoPremiacao from '@/modules/projeto/components/detalhesSolicitacao/LabelsPagamentoPremiacao.vue';
import LabelsPagamentoServico from '@/modules/projeto/components/detalhesSolicitacao/LabelsPagamentoServico.vue';
import LabelsDiaria from '@/modules/projeto/components/detalhesSolicitacao/LabelsDiaria.vue';
import LabelsPagamentoBolsa from '@/modules/projeto/components/detalhesSolicitacao/LabelsPagamentoBolsa.vue';
import LabelsCancelamentoContrato from '@/modules/projeto/components/detalhesSolicitacao/LabelsCancelamentoContrato.vue';
import LabelsRepasseApoiada from '@/modules/projeto/components/detalhesSolicitacao/LabelsRepasseApoiada.vue';
import LabelsDevolucaoOrgaoFinanciador from '@/modules/projeto/components/detalhesSolicitacao/LabelsDevolucaoOrgaoFinanciador.vue';
import LabelsRetiradaRendimento from '@/modules/projeto/components/detalhesSolicitacao/LabelsRetiradaRendimento.vue';
import LabelsTransferenciaBancaria from '@/modules/projeto/components/detalhesSolicitacao/LabelsTransferenciaBancaria.vue';
import LabelsReceitaPorEncerramento from '@/modules/projeto/components/detalhesSolicitacao/LabelsReceitaPorEncerramento.vue';

export function setupGlobalComponents(app) {
  app.component('LabelsGerais', LabelsGerais);
  app.component('LabelsMateriais', LabelsMateriais);
  app.component('LabelsServicos', LabelsServicos);
  app.component('LabelsLocacao', LabelsLocacao);
  app.component('LabelsPassagem', LabelsPassagem);
  app.component('LabelsHospedagem', LabelsHospedagem);
  app.component('LabelsRecargaCartao', LabelsRecargaCartao);
  app.component('LabelsCadastroPJ', LabelsCadastroPJ);
  app.component('LabelsCadastroPF', LabelsCadastroPF);
  app.component('LabelsPagamentoMaterial', LabelsPagamentoMaterial);
  app.component('LabelsPagamentoPremiacao', LabelsPagamentoPremiacao);
  app.component('LabelsPagamentoServico', LabelsPagamentoServico);
  app.component('LabelsDiaria', LabelsDiaria);
  app.component('LabelsPagamentoBolsa', LabelsPagamentoBolsa);
  app.component('LabelsCancelamentoContrato', LabelsCancelamentoContrato);
  app.component('LabelsRepasseApoiada', LabelsRepasseApoiada);
  app.component('LabelsDevolucaoOrgaoFinanciador', LabelsDevolucaoOrgaoFinanciador);
  app.component('LabelsRetiradaRendimento', LabelsRetiradaRendimento);
  app.component('LabelsTransferenciaBancaria', LabelsTransferenciaBancaria);
  app.component('LabelsReceitaPorEncerramento', LabelsReceitaPorEncerramento);

  app.component('SmallTitle', SmallTitle);
  app.component('SmallError', SmallError);
  app.component('EditorTexto', EditorTexto);

  app.component('BotaoAba', BotaoAba);
  app.component('AbaNavegacao', AbaNavegacao);
  // eslint-disable-next-line vue/multi-word-component-names
  app.component('Carregador', Carregador);
  app.component('BotaoRascunho', BotaoRascunho);

  app.component('TabelaHistorico', TabelaHistorico);
  app.component('CardMobile', CardMobile);
  app.component('CardInformacao', CardInformacao);
  app.component('CardArquivo', CardArquivo);
  app.component('TourGuiado', TourGuiado);
  app.component('LeitorPdf', LeitorPdf);
  app.component('ReturnTrail', ReturnTrail);
  app.component('LabelDados', LabelDados);

  app.component('TagStatus', TagStatus);
  app.component('TagStatusSolicitacoes', TagStatusSolicitacoes);
  app.component('TagStatusPagamentos', TagStatusPagamentos);
  app.component('TagStatusContratacao', TagStatusContratacao);
  app.component('TagStatusRelatorioViagem', TagStatusRelatorioViagem);
  app.component('TagStatusSolicitacaoPagamentoBeneficio', TagStatusSolicitacaoPagamentoBeneficio);
  app.component('TagStatusDiaria', TagStatusDiaria);
  app.component('TagDefault', TagDefault);
  app.component('TagBase', TagBase);

  app.component('CabecalhoFormSolicitacoes', CabecalhoFormSolicitacoes);
  app.component('CabecalhoListas', CabecalhoListas);
  app.component('ColunaListas', ColunaListas);
  app.component('CardMobileLista', CardMobileLista);
  app.component('PaginadorTabela', PaginadorTabela);
  app.component('CampoBuscaLista', CampoBuscaLista);
  app.component('BotaoFiltroToggle', BotaoFiltroToggle);
  app.component('BotaoFiltro', BotaoFiltro);
  app.component('BotaoExibirTodos', BotaoExibirTodos);

  app.component('CboInput', CboInput);
  app.component('RubricaInputNew', RubricaInputNew);
  app.component('RubricaInput', RubricaInput);
  app.component('MetaInput', MetaInput);
  app.component('DetalhamentoInput', DetalhamentoInput);
  app.component('PropostaReferenciaInput', PropostaReferenciaInput);

  app.component('DialogoFormulario', DialogoFormulario);
  app.component('DialogoDetalhe', DialogoDetalhe);
  app.component('DialogoLista', DialogoLista);
  app.component('DialogoPdf', DialogoPdf);
  app.component('InfoInstrucaoArquivo', InfoInstrucaoArquivo);

  app.component('BaseCadastros', BaseCadastros);
  app.component('FormCadastros', FormCadastros);
  app.component('CabecalhoCadastros', CabecalhoCadastros);
  app.component('DivisaoCadastros', DivisaoCadastros);

  app.component('RubricaCampo', Rubrica);
  app.component('RubricaDetalhamentoCampo', RubricaDetalhamento);
  app.component('MetaCampo', Meta);
  app.component('TextoCampo', TextoCampo);
  app.component('TextoMaskCampo', TextoMaskCampo);
  app.component('DropdownCampo', DropdownCampo);
  app.component('MultiSelectCampo', MultiSelectCampo);
  app.component('RadioCampo', RadioCampo);
  app.component('SelectButtonCampo', SelectButtonCampo);
  app.component('TextoAreaCampo', TextoAreaCampo);
  app.component('DataPagamentoCampo', DataPagamento);
  app.component('ArquivoCampo', Arquivo);
  app.component('TipoSolicitacaoCampo', TipoSolicitacao);
  app.component('TipoSolicitacaoFinanceiroCampo', TipoSolicitacaoFinanceiro);
  app.component('MembroCampo', Membros);
  app.component('MembroPagamentoCampo', MembroPagamento);
  app.component('ValorCampo', Valor);
  app.component('ValorNumericoCampo', ValorNumericoCampo);
  app.component('SwitchCampo', Switch);
  app.component('PessoaFisicaCampo', PessoaFisica);
  app.component('ProjetoCampo', Projeto);
  app.component('PessoaJuridicaCampo', PessoaJuridica);
  app.component('AvisoCoordenacaoCampo', AvisoCoordenacao);
  app.component('ContaBancariaCampo', ContaBancaria);
  app.component('ContaBancariaCampoValidado', ContaBancariaCampoValidado);

  app.component('ListasGenericas', ListasGenericas);
  app.component('TabelaScrollContainer', TabelaScrollContainer);
  app.component('BaseDetalhes', BaseDetalhes);

  app.component('QrcodeVue', QrcodeVue);
}
